function getMatchDateTime(match) {
  if (match.provisionalStartDate) {
    return match.provisionalStartDate
  }
  return match.dateTime
}

export default getMatchDateTime
